import { render, staticRenderFns } from "./workLvMoney.vue?vue&type=template&id=bfdb96a6&"
import script from "./workLvMoney.vue?vue&type=script&lang=js&"
export * from "./workLvMoney.vue?vue&type=script&lang=js&"
import style0 from "./workLvMoney.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports